/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OnlineTransactionResponseDto { 
    id?: string;
    paymentProvider?: string | null;
    memberName?: string | null;
    amount?: number;
    currency?: string | null;
    accountNumber?: string | null;
    paymentServiceProviderName?: string | null;
    transactionRefrenceId?: string | null;
    createTime?: string;
    errorMessage?: string | null;
    requestPayload?: string | null;
    paymentTransactionStatusId?: number;
    paymentTransactionStatus?: string | null;
    paymentTransactionModeId?: number | null;
    paymentTransactionMode?: string | null;
    type?: string | null;
}

